/* eslint-disable */
import * as utilLogin from "@/api/login";
import { setShowModalOnlineDemo, removeShowModalOnlineDemo, getShowModalOnlineDemo, removeShowModalPromo, getShowModalPromo, setShowModalPromo, removeMemberSession, setMemberSession, getMemberSession, setXAuthAgent, setAgentSession, removeAgentSession, removeXAuthAgent, setXAuthToken, removeXAuthToken, isImpersonating, beginImpersonationSession, endImpersonationSession, discardImpersonationSession } from "@/utils/auth";

const state = {
    roles: [],
    username: "",
    password: "",
    x_auth_token: "",
    // showModalOnlineDemo: (getShowModalOnlineDemo() != null) ? getShowModalOnlineDemo() : null,
    showModalOnlineDemo: "hide",
    showModalPromo: (getShowModalPromo() != null) ? getShowModalPromo() : null,
    memberSession: (getMemberSession() != null) ? JSON.parse(getMemberSession()) : null,
    // Diinisialisasi dari localStorage agar banner impersonation tetap muncul
    // setelah refresh dan tidak pernah berasal dari query string.
    isImpersonation: isImpersonating(),
};

const mutations = {
    SET_showModalOnlineDemo: (state, value) => {
        state.showModalOnlineDemo = value
    },
    SET_showModalPromo: (state, value) => {
        state.showModalPromo = value
    },
    SET_memberSession: (state, value) => {
        state.memberSession = value
    },
    SET_x_auth_token: (state, value) => {
        state.x_auth_token = value
    },
    SET_isImpersonation: (state, value) => {
        state.isImpersonation = value
    },
    SET_Roles: (state, value) => {
        state.roles = value
    },
};

const actions = {
    actHideModalOnlineDemo({ commit }) {
        commit("SET_showModalOnlineDemo", "hide");
        setShowModalOnlineDemo("hide");
    },
    actHideModalPromo({ commit }) {
        commit("SET_showModalPromo", "hide");
        setShowModalPromo("hide");
    },
    loginAgentStored({ commit, dispatch }, dataParams) {
        commit("SET_x_auth_token", "");
        removeXAuthToken();
        removeXAuthAgent("");
        removeAgentSession({ "agentSession": {} });

        return new Promise((resolve, reject) => {
            utilLogin.loginAgentStored(dataParams).then(response => {
                const { data } = response;
                setXAuthToken(data.x_auth_token)
                commit("SET_x_auth_token", data.x_auth_token);
                setXAuthAgent(data.x_auth_agent)
                setAgentSession(data)
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getBankList({ commit }) {
        return new Promise((resolve, reject) => {
            utilLogin.getBankList().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getBank({ commit }) {
        return new Promise((resolve, reject) => {
            utilLogin.getBank().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getProfile({ commit }, dataParams) {
        const silent = !!(dataParams && dataParams.silent);
        commit("SET_memberSession", {
            "email": "",
            "id": "",
            "name": "",
            "phone": "",
            "roles": [],
            "timezone": "Asia/Jakarta"
        });

        return new Promise((resolve, reject) => {
            const request = silent
                ? utilLogin.verifyImpersonationProfile()
                : utilLogin.getProfile(dataParams);
            request.then(response => {
                const { data } = response;
                if (!data) {
                    reject('Verification failed, please Login again.')
                    return;
                }

                const { roles } = data

                // roles must be a non-empty array
                if (!roles || roles.length <= 0) {
                    reject('getInfo: roles must be a non-null array!')
                    return;
                }
                commit("SET_memberSession", data);
                setMemberSession(data)

                commit("SET_Roles", data.roles);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setFields({ commit }, data) {
        commit("SET_fields", data);
    },
    // Inisialisasi sesi member yang dipakai bersama oleh login normal dan
    // impersonation. Ini adalah langkah yang sama dengan yang dilakukan
    // login.vue setelah response login sukses:
    //  - simpan access token,
    //  - isi Vuex x_auth_token,
    //  - kosongkan sesi agent (Agent-Token/Agent-Session) agar tidak ada
    //    header X-Auth-Agent lama yang mengganggu request dashboard,
    //  - kosongkan roles agar guard/initializer memuat profile dan permission.
    establishMemberSession({ commit, dispatch }, payload) {
        if (payload.impersonation) {
            beginImpersonationSession(payload.token);
        } else {
            discardImpersonationSession();
            setXAuthToken(payload.token);
        }

        commit("SET_x_auth_token", payload.token);
        commit("SET_isImpersonation", !!payload.impersonation);
        commit("SET_memberSession", {
            "email": "",
            "id": "",
            "name": "",
            "phone": "",
            "roles": [],
            "timezone": "Asia/Jakarta"
        });
        commit("SET_Roles", []);

        removeXAuthAgent("");
        removeAgentSession({ "agentSession": {} });
        return Promise.all([
            dispatch("agent/setAgentSession", { agentSession: {} }, { root: true }),
            dispatch("agent/setXAuthAgent", "", { root: true })
        ]);
    },
    // Menukar kode handoff dari ZEUS dengan token member, lalu menjalankan
    // inisialisasi sesi yang sama dengan login normal.
    exchangeHandoff({ commit, dispatch }, dataParams) {
        return new Promise((resolve, reject) => {
            utilLogin.exchangeMemberHandoff(dataParams).then(async response => {
                const data = (response && response.data) || {};
                if (!data.x_auth_token) {
                    reject(new Error("Token member tidak diterima dari server."));
                    return;
                }
                try {
                    await dispatch("establishMemberSession", {
                        token: data.x_auth_token,
                        impersonation: true
                    });
                    resolve(response);
                } catch (error) {
                    reject(error);
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
    loginMemberValidation({ commit }, dataParams) {
        // console.log(dataParams)
        commit("SET_x_auth_token", "");
        discardImpersonationSession()
        removeXAuthToken()
        removeMemberSession()
        removeAgentSession({ "agentSession": {} });
        removeXAuthAgent("");
        commit("SET_isImpersonation", false);

        commit("SET_memberSession", {
            "email": "",
            "id": "",
            "name": "",
            "phone": "",
            "roles": [],
            "timezone": "Asia/Jakarta"
        });
        return new Promise((resolve, reject) => {
            utilLogin.loginMemberValidation(dataParams).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    loginMemberStored({ commit, dispatch }, dataParams) {
        commit("SET_x_auth_token", "");
        discardImpersonationSession()
        removeXAuthToken();
        removeMemberSession()
        commit("SET_isImpersonation", false);
        commit("SET_memberSession", {
            "email": "",
            "id": "",
            "name": "",
            "phone": "",
            "roles": [],
            "timezone": "Asia/Jakarta"
        });

        removeXAuthAgent("");
        removeAgentSession({ "agentSession": {} });
        // dispatch("/agent/setAgentSession", { "agentSession": {} })
        // dispatch("/agent/setXAuthAgent", "")


        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            utilLogin.loginMemberStored(dataParams).then(response => {
                const { data } = response;
                dispatch("establishMemberSession", {
                    token: data.x_auth_token,
                    impersonation: false
                }).then(() => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            }).catch(error => {
                reject(error);
            });
        });
    },
    logout({ commit }, dataParams) {

        return new Promise((resolve, reject) => {
            utilLogin.logout(dataParams).then(response => {
                commit("SET_memberSession", {
                    "email": "",
                    "id": "",
                    "name": "",
                    "phone": "",
                    "roles": [],
                    "timezone": "Asia/Jakarta"
                });
                removeMemberSession()
                // const { data } = response;
                commit('SET_x_auth_token', '')
                commit('SET_Roles', [])
                removeXAuthToken()
                removeXAuthAgent("");
                removeAgentSession({ "agentSession": {} });
                removeShowModalPromo();
                removeShowModalOnlineDemo();
                discardImpersonationSession();
                commit("SET_isImpersonation", false);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    removeXAuthToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_x_auth_token', '')
            commit('SET_Roles', [])
            // Jika sesi impersonation yang gagal, buang backup-nya juga agar
            // tidak ada sesi lama yang tiba-tiba dipulihkan.
            discardImpersonationSession()
            removeXAuthToken()
            commit('SET_isImpersonation', false)

            resolve()
        })
    },
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit("SET_memberSession", {
                "email": "",
                "id": "",
                "name": "",
                "phone": "",
                "roles": [],
                "timezone": "Asia/Jakarta"
            });
            discardImpersonationSession()
            removeMemberSession()
            // const { data } = response;
            commit('SET_x_auth_token', '')
            commit('SET_Roles', [])
            removeXAuthToken()
            removeXAuthAgent("");
            removeAgentSession({ "agentSession": {} });
            removeShowModalPromo();
            commit('SET_isImpersonation', false)

            resolve()
        })
    },
    // Mengakhiri impersonation dan memulihkan sesi sebelumnya (bila ada).
    endImpersonationLocal({ commit }) {
        endImpersonationSession();
        commit("SET_memberSession", null);
        commit("SET_isImpersonation", false);
        commit("SET_x_auth_token", "");
        commit("SET_Roles", []);
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/login.js